export interface LogEvent {
  message: string;
  status: string;
  origin?: string;
  http?: {
    status_code?: number;
  };
}

interface LogModification {
  check: (event: LogEvent) => boolean;
  modify: (event: LogEvent) => void;
}

const logModifications: LogModification[] = [
  {
    check: event => event.message.includes('Minified React error'),
    modify: event => {
      event.status = 'warn';
    },
  },
  {
    check: event => event.message.includes('ResizeObserver loop completed with undelivered notifications'),
    modify: event => {
      event.status = 'warn';
    },
  },
  {
    // status_code 0 means the request never got an HTTP response (page unload,
    // connection drop, VPN blip) — not a server error, so don't alarm on it
    check: event => event.origin === 'network' && event.http?.status_code === 0,
    modify: event => {
      event.status = 'warn';
    },
  },
];

export function applyPreSendLogModifications(event: LogEvent) {
  for (const { check, modify } of logModifications) {
    if (check(event)) {
      modify(event);
    }
  }
}
